import React, { useEffect, useRef, useState } from "react";

interface TypingTextProps {
  texts: string[];
  typingSpeed?: number;
  pauseTime?: number;
  children: React.ReactElement<{ children?: React.ReactNode }>;
}
export const TypingText: React.FC<TypingTextProps> = ({
  texts,
  typingSpeed = 100,
  pauseTime = 2000,
  children,
}) => {
  const [displayedText, setDisplayedText] = useState<string>("");
  const [textIndex, setTextIndex] = useState<number>(0);
  const [isDeleting, setIsDeleting] = useState<boolean>(false);
  const timeoutId = useRef<NodeJS.Timeout | null>(null);

  // Сброс индекса и состояния при изменении списка текстов
  useEffect(() => {
    if (texts.length === 0) {
      console.warn("No texts provided to TypingText component.");
      setDisplayedText("");
      setTextIndex(0);
      setIsDeleting(false);
      return;
    }
    setTextIndex(0);
    setIsDeleting(false);
  }, [texts]);

  useEffect(() => {
    if (texts.length === 0) return;

    const currentText = texts[textIndex];

    const handleTyping = () => {
      if (!isDeleting && displayedText.length < currentText.length) {
        // Печать текста
        setDisplayedText(currentText.substring(0, displayedText.length + 1));
      } else if (isDeleting && displayedText.length > 1) {
        // Удаление текста, оставляя последний символ
        setDisplayedText(currentText.substring(0, displayedText.length - 1));
      } else if (displayedText.length === currentText.length && !isDeleting) {
        // Пауза перед удалением
        timeoutId.current = setTimeout(() => setIsDeleting(true), pauseTime);
      } else if (isDeleting && displayedText.length === 1) {
        // Переключение на следующий текст
        setIsDeleting(false);
        setTextIndex((prevIndex) => (prevIndex + 1) % texts.length);
      }
    };

    timeoutId.current = setTimeout(handleTyping, typingSpeed);

    return () => {
      if (timeoutId.current) clearTimeout(timeoutId.current);
    };
  }, [displayedText, isDeleting, textIndex, texts, typingSpeed, pauseTime]);

  return React.cloneElement(children, { children: displayedText });
};
